import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../../lib/session';

const TABS = [
  { to: 'company', key: 'settings.tabs.company', perm: 'settings:read' },
  { to: 'users', key: 'settings.tabs.users', perm: 'users:read' },
  { to: 'roles', key: 'settings.tabs.roles', perm: 'roles:read' },
  { to: 'devices', key: 'settings.tabs.devices', perm: 'devices:read' },
];

export function SettingsLayout() {
  const { t } = useTranslation();
  const can = useSession((s) => s.can);
  return (
    <div className="flex flex-col gap-5">
      <nav className="flex gap-1 overflow-x-auto rounded-lg bg-surface-2 p-1" aria-label={t('nav.settings')}>
        {TABS.filter((x) => can(x.perm)).map((x) => (
          <NavLink
            key={x.to}
            to={x.to}
            className={({ isActive }) => clsx('min-h-9 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium', isActive ? 'bg-surface text-brand-ink shadow-card' : 'text-text-muted hover:text-text')}
          >
            {t(x.key)}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
